import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import LocalizedStrings from "react-localization";
import { usePapaParse, useCSVReader, formatFileSize } from "react-papaparse";
import { Checkbox } from "material-ui";
import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables";
import { ExportToCsv } from "export-to-csv";

//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    TagInformation: "Tag Info",
    TagName: "Tag Name",
    TagId: "Tag ID",
    ImportStatus: "Import Status",
    permission: "Permission",
    showInfoButton: "Show Info",
    remarkHeader: "Remark",
    approvalAllow: "Approved",
    approvalDeny: "Denied",
    approvalPending: "Pending",
    none: "None",
    noDataTitle: "No data found",
    tagListHeader: "Tag List",
    CSVTemplateTitle: "CSV Template: ",
    CSVDownloadTitle: "Download CSV",
    importBtnTitle: "Import",
    exportBtnTitle: "Export Tags",
    addImportHeader: "Add / Import Tags",
    addLabel: "Add",
    removeSelectedLabel: "Remove Selected",
    addTagsLabel: "Add Tags",
    PasscodeInformation: "Passcode Info",
    passcodeListHeader: "Passcode List",
    PasscodeName: "Passcode Name",
    Passcode: "Passcode",
    addPasscodeLabel: "Add Passcodes",
    directionalCodeLabel: "Directional Code :",
    tagErrorMessage1: "Tag Name already exists. ",
    tagErrorMessage2: "Tag ID already exists. ",
    tagErrorMessage3:
      "Invalid Tag ID: Must be 4 hexadecimal characters without spaces. [A-F, 0-9]",
    passcodeErrorMessage1: "Passcode Name already exists. ",
    passcodeErrorMessage2: "Passcode already exists. ",
    passcodeErrorMessage3:
      "Invalid Passcode: Must be 6 numeric characters without spaces.",
    manageTags: "Manage Tags",
    managePasscodes: "Manage Passcodes",
    confirmAddTagHeader: "Confirmation of Tags",
    confirmAddPasscodeHeader: "Confirmation of Passcodes",
    tagsAddedNotification: "Tags have been added to ",
    passcodesAddedNotification: "Passcodes have been added to ",
    tagsRemovedNotification: "Tags have been removed from ",
    passcodesRemovedNotification: "Passcodes have been removed from ",
    notificationEnd: " !",
  },
  ja: {
    TagInformation: "NFC利用状況",
    TagName: "NFC名称",
    TagId: "NFC ID",
    ImportStatus: "インポート状況",
    permission: "許可",
    showInfoButton: "情報を表示",
    remarkHeader: "理由",
    approvalPending: "保留中",
    approvalAllow: "承認する",
    approvalDeny: "拒否",
    none: "なし",
    noDataTitle: "データーがありません",
    tagListHeader: "タグ一覧",
    CSVTemplateTitle: "CSVテンプレート: ",
    CSVDownloadTitle: "CSVをダウンロード",
    importBtnTitle: "インポート",
    exportBtnTitle: "タグをエクスポート",
    addImportHeader: "タグを追加/インポート",
    addLabel: "追加",
    removeSelectedLabel: "選択したものを削除",
    addTagsLabel: "タグを追加",
    PasscodeInformation: "パスコード情報",
    passcodeListHeader: "パスコードリスト",
    PasscodeName: "パスコード名",
    Passcode: "パスコード",
    addPasscodeLabel: "パスコードを追加",
    directionalCodeLabel: "方向コード：",
    tagErrorMessage1: "タグ名はすでに存在します。 ",
    tagErrorMessage2: "タグIDはすでに存在します。 ",
    tagErrorMessage3:
      "無効なタグ ID: スペースを含まない 4 つの 16 進文字である必要があります。 [A-F、0-9]",
    passcodeErrorMessage1: "パスコード名はすでに存在します。 ",
    passcodeErrorMessage2: "パスコードはすでに存在します。 ",
    passcodeErrorMessage3:
      "無効なパスコード: 6桁の数字でスペースを含まない必要があります。",
    manageTags: "タグを管理",
    managePasscodes: "パスコードを管理",
    confirmAddTagHeader: "タグの確認",
    confirmAddPasscodeHeader: "パスコードの確認",
    tagsAddedNotification: "タグが追加されました：",
    passcodesAddedNotification: "パスコードが追加されました：",
    tagsRemovedNotification: "タグが削除されました：",
    passcodesRemovedNotification: "パスコードが削除されました：",
    notificationEnd: "！",
  },
  es: {
    TagInformation: "Info de la Etiqueta",
    TagName: "Nombre de la Etiqueta",
    TagId: "ID de la Etiqueta",
    ImportStatus: "Estado de Importación",
    permission: "Permiso",
    showInfoButton: "Mostrar Info",
    remarkHeader: "Observación",
    approvalAllow: "Aprobado",
    approvalDeny: "Denegado",
    approvalPending: "Pendiente",
    none: "Ninguno",
    noDataTitle: "No se encontraron datos",
    tagListHeader: "Lista de Etiquetas",
    CSVTemplateTitle: "Plantilla CSV: ",
    CSVDownloadTitle: "Descargar CSV",
    importBtnTitle: "Importar",
    exportBtnTitle: "Exportar Etiquetas",
    addImportHeader: "Agregar / Importar Etiquetas",
    addLabel: "Agregar",
    removeSelectedLabel: "Eliminar Seleccionado",
    addTagsLabel: "Agregar Etiquetas",
    PasscodeInformation: "Info de Código de Acceso",
    passcodeListHeader: "Lista de Códigos de Acceso",
    PasscodeName: "Nombre del Código de Acceso",
    Passcode: "Código de Acceso",
    addPasscodeLabel: "Agregar Códigos",
    directionalCodeLabel: "Código Direccional:",
    tagErrorMessage1: "El nombre de la etiqueta ya existe. ",
    tagErrorMessage2: "La ID de la etiqueta ya existe. ",
    tagErrorMessage3:
      "ID de etiqueta no válido: Debe tener 4 caracteres hexadecimales sin espacios. [A-F, 0-9]",
    passcodeErrorMessage1: "El nombre del código de acceso ya existe. ",
    passcodeErrorMessage2: "El código de acceso ya existe. ",
    passcodeErrorMessage3:
      "Código de acceso inválido: debe ser de 6 caracteres numéricos sin espacios.",
    manageTags: "Gestionar Etiquetas",
    managePasscodes: "Gestionar Códigos",
    confirmAddTagHeader: "Confirmación de Etiquetas",
    confirmAddPasscodeHeader: "Confirmación de Códigos",
    tagsAddedNotification: "Las etiquetas han sido añadidas a ",
    passcodesAddedNotification: "Los códigos han sido añadidos a ",
    tagsRemovedNotification: "Las etiquetas han sido eliminadas de ",
    passcodesRemovedNotification: "Los códigos han sido eliminados de ",
    notificationEnd: " !",
  },
});

class TagInfoButton extends Component {
  constructor(props) {
    super(props);

    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handleString = this.handleString.bind(this);
    this.handleExportCSV = this.handleExportCSV.bind(this);
    const lockserial = this.props.lockSerial;
    const lockType = this.props.lockType;
    const lockName = this.props.lockName;

    this.state = {
      lockserial: lockserial,
      lockType: lockType,
      lockName: lockName,
      noDataText: "loading...",
      showPopup: false,
      loading: false,
      adminName: "",
      csvdata: {},
      importedTagInformation: [],
      importedPasscodeInformation: [],
      selectedTags: [],
      selectedPasscodes: [],
      selectedDBTags: [],
      selectedDBPasscodes: [],
      selectedAddType: "add",
      inputTagName: "",
      inputTagID: "",
      inputPasscodeName: "",
      inputPasscode: "",
      _notificationSystem: null,
      planLimits: {
        maxTagsPerLock: null,
        maxPasscodesPerLock: null,
      },
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.loadPlanLimits();
  }

  componentWillMount() {
    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  getRemainingTags(existingCount = 0) {
    const lim = this.state.planLimits?.maxTagsPerLock;
    if (lim == null) return Infinity;
    return Math.max(lim - existingCount, 0);
  }

  getRemainingPasscodes(existingCount = 0) {
    const lim = this.state.planLimits?.maxPasscodesPerLock;
    if (lim == null) return Infinity;
    return Math.max(lim - existingCount, 0);
  }
  // Finds the super admin that owns the current user (or the user themself if they are a super admin),
  // checks maxLocks, updates a few flags in state, and returns the superAdminID.
  // Usage: const superadminUID = await this.resolveSuperadminUID();
  resolveSuperadminUID = async () => {
    const currUser = auth.currentUser;
    if (!currUser) return null;

    const userEmail = String(currUser.email || "").toLowerCase();

    return new Promise((resolve) => {
      fire
        .database()
        .ref("groupAccounts")
        .once("value")
        .then((snapshot) => {
          if (!snapshot.exists()) {
            resolve(null);
            return;
          }

          let foundSuperAdminID = null;

          // Iterate all super admins
          snapshot.forEach((superAdminSnap) => {
            if (foundSuperAdminID) return; // already found

            const superAdminID = superAdminSnap.key;
            const superAdminData = superAdminSnap.val() || {};
            const memberDetails = superAdminData.members || {};

            // Case 1: current user IS the super admin
            if (superAdminID === (currUser.uid || "")) {
              foundSuperAdminID = superAdminID;
            }

            // Case 2: user is a member under this super admin (email match)
            if (!foundSuperAdminID) {
              for (let eachMemberId in memberDetails) {
                const eachMember = memberDetails[eachMemberId] || {};
                const eachMemberEmail = String(
                  eachMember.memberEmail || ""
                ).toLowerCase();
                if (eachMemberEmail === userEmail) {
                  foundSuperAdminID = superAdminID;

                  // Optional flags to state (if your UI needs them)
                  this.setState({
                    isAdmin: !!eachMember.isAdmin,
                    isSuperAdmin: !!eachMember.isSuperAdmin,
                    superAdminID: superAdminID,
                  });
                  break;
                }
              }
            }

            // If we just determined a super admin, optionally check lock limits immediately
            if (foundSuperAdminID) {
              const payment = superAdminData.payment || {};
              const maxUserLocks = Number(payment.maxLocks || 0);

              // Only check if maxLocks is a positive number
              if (maxUserLocks > 0) {
                fire
                  .database()
                  .ref("MyAdminLocks/" + foundSuperAdminID)
                  .once("value")
                  .then((locksSnap) => {
                    const childInDb = locksSnap.exists()
                      ? locksSnap.numChildren()
                      : 0;
                    if (childInDb > maxUserLocks) {
                      // Make sure you have this string in your localization bundle if you use it
                      this.showNotification(
                        localizationStrings.exceededLockLimits ||
                          "You have exceeded your lock limits.",
                        "error",
                        5,
                        "" // allow dismiss
                      );
                    }
                  })
                  .catch(() => {});
              }
            }
          });

          resolve(foundSuperAdminID);
        })
        .catch(() => resolve(null));
    });
  };

  // Load limits from /groupAccounts/<superadminUID>/payment
  loadPlanLimits = async () => {
    try {
      const superadminUID = await this.resolveSuperadminUID();
      if (!superadminUID) {
        this.setState({
          planLimits: { maxTagsPerLock: 200, maxPasscodesPerLock: 100 },
        });
        return;
      }

      const paymentSnap = await fire
        .database()
        .ref(`groupAccounts/${superadminUID}/payment`)
        .once("value");

      let maxTagsPerLock = null;
      let maxPasscodesPerLock = null;

      if (paymentSnap.exists()) {
        const pay = paymentSnap.val() || {};
        // <<— from your screenshot —>>
        maxTagsPerLock = pay.maxTags ?? null;

        // Optional future field names for passcodes:
        maxPasscodesPerLock = pay.maxPasscodes ?? pay.passcodeLimit ?? null;
      }

      this.setState({
        planLimits: {
          maxTagsPerLock: maxTagsPerLock ?? 200,
          maxPasscodesPerLock: maxPasscodesPerLock ?? 100,
        },
      });
    } catch (err) {
      console.error("loadPlanLimits error:", err);
      this.setState({
        planLimits: { maxTagsPerLock: 200, maxPasscodesPerLock: 100 },
      });
    }
  };

  handlePopupOpen() {
    this.setState({
      showPopup: true,
    });

    let TagInformation = [];
    let PasscodeInformation = [];

    if (
      this.state.lockType === 7 ||
      this.state.lockType === 8 ||
      this.state.lockType === 9
    ) {
      // console.log("Display Passcodes List")

      fire
        .database()
        .ref("directionalPasscodeList")
        .child(this.state.lockserial)
        .once("value")
        .then((snapshot) => {
          snapshot.forEach((snapshotChild) => {
            let passcodeData = snapshotChild.val();

            // if (passcodeData.imported === undefined) {
            //   passcodeData.imported = "N/A";
            // } else if (passcodeData.imported === false) {
            //   passcodeData.imported = "Pending";
            // } else if (passcodeData.imported === true) {
            //   passcodeData.imported = "Synced";
            // }

            PasscodeInformation.push(passcodeData);
          });
        })
        .then(() => {
          this.setState({
            PasscodeInformation: PasscodeInformation,
          });
          customLog(PasscodeInformation);
        });

      if (PasscodeInformation.length <= 0) {
        this.setState({
          noDataText: localizationStrings.noDataTitle,
        });
      }
    } else {
      // console.log("Display Tags List")

      fire
        .database()
        .ref("nfcTagList")
        .child(this.state.lockserial)
        .once("value")
        .then((snapshot) => {
          snapshot.forEach((snapshotChild) => {
            let tagData = snapshotChild.val();

            if (tagData.imported === undefined) {
              tagData.imported = "N/A";
            } else if (tagData.imported === false) {
              tagData.imported = "Pending";
            } else if (tagData.imported === true) {
              tagData.imported = "Synced";
            }

            TagInformation.push(tagData);
          });
        })
        .then(() => {
          this.setState({
            TagInformation: TagInformation,
          });
          customLog(TagInformation);
        });

      if (TagInformation.length <= 0) {
        this.setState({
          noDataText: localizationStrings.noDataTitle,
        });
      }
    }
  }

  handlePopupClose() {
    this.setState({
      showPopup: false,
      errorMessage: null,
      importedTagInformation: [],
      selectedTags: [],
      inputTagName: "",
      inputTagID: "",
      selectedAddType: "add",
      importedPasscodeInformation: [],
      selectedPasscodes: [],
      inputPasscodeName: "",
      inputPasscode: "",
      selectedDBTags: [],
      selectedDBPasscodes: [],
    });
  }

  remarkFormat(remark) {
    if (remark !== null && remark !== undefined && remark !== "") {
      return remark;
    } else {
      return localizationStrings.none;
    }
  }

  // adminNameFormat(adminUid) {

  //   fire
  //     .database()
  //     .ref("registeredIndustrialUsersOnPlatform")
  //     .child(adminUid)
  //     .once("value")
  //     .then(async usersDetail => {
  //       await this.setState({
  //         adminName: usersDetail.val().name
  //       });
  //     })
  // }

  handleString(CSVFile) {
    const { readString } = usePapaParse();
    const prevTagList = [...this.state.TagInformation];
    const prevImportedTags = [...this.state.importedTagInformation];
    let duplicateError = false;
    let invalidTagIDError = false;
    let duplicateTagsInCSV = [];
    let invalidTagIDs = [];
    let tagsToAdd = [];

    const tagNameList = [
      ...prevTagList.map((tag) => tag.tagName),
      ...prevImportedTags.map((tag) => tag.tagName),
    ];
    const tagIdList = [
      ...prevTagList.map((tag) => tag.tagId),
      ...prevImportedTags.map((tag) => tag.tagId),
    ];

    const isValidTagID = (tagId) => /^[A-Fa-f0-9]{4}$/.test(tagId); // Ensure Tag-ID is 4 hexadecimal characters

    readString(CSVFile, {
      worker: true,
      header: true,
      delimiter: ";",
      complete: (results) => {
        if (
          results.meta.fields.includes("No.") &&
          results.meta.fields.includes("Tag-Name") &&
          results.meta.fields.includes("Tag-ID")
        ) {
          results.data.forEach((row) => {
            // Skip empty or invalid rows
            if (!row["Tag-Name"] || !row["Tag-ID"] || !row["No."]) {
              return;
            }

            const tagName = row["Tag-Name"] ? row["Tag-Name"].trim() : "";
            const tagId = row["Tag-ID"] ? row["Tag-ID"].trim() : "";
            const rowNum = row["No."] ? row["No."].trim() : "N/A";

            if (!tagName || !tagId) {
              return; // Skip rows with missing tagName or tagId even after trimming
            }

            const formattedTagId = ` ${tagId
              .slice(0, 2)
              .toUpperCase()} ${tagId.slice(2, 4).toUpperCase()} `;

            // Check for duplicates within the CSV itself
            const isDuplicateInCSV =
              results.data.filter((item) => {
                const itemTagName = item["Tag-Name"]
                  ? item["Tag-Name"].trim()
                  : "";
                const itemTagId = item["Tag-ID"] ? item["Tag-ID"].trim() : "";
                return itemTagName === tagName || itemTagId === tagId;
              }).length > 1;

            // Check for duplicates in the existing database
            const isDuplicateInDB =
              tagNameList.includes(tagName) ||
              tagIdList.includes(formattedTagId);

            // Validate the Tag-ID
            const isValidID = isValidTagID(tagId);

            if (isDuplicateInCSV || isDuplicateInDB) {
              duplicateError = true;
              duplicateTagsInCSV.push(`Row ${rowNum}: [${tagName}, ${tagId}]`);
            }

            if (!isValidID) {
              invalidTagIDError = true;
              invalidTagIDs.push(`Row ${rowNum}: [${tagId}]`);
            }

            // If no errors, add the tags to imported tags table
            if (!isDuplicateInCSV && !isDuplicateInDB && isValidID) {
              tagsToAdd.push({
                tagName: tagName,
                tagId: formattedTagId,
              });
            }
          });

          // If there are errors, display the error messages
          if (duplicateError || invalidTagIDError) {
            let errorMessage = "";
            if (duplicateError) {
              errorMessage += `Duplicate tags: ${duplicateTagsInCSV.join(
                ", "
              )}.\n`;
            }
            if (invalidTagIDError) {
              errorMessage += `Invalid Tag-IDs: ${invalidTagIDs.join(", ")}.\n`;
            }
            this.setState({ errorMessage });
          } else {
            const importedTags = tagsToAdd.map((tag) => ({
              ...tag,
            }));

            this.setState((prevState) => ({
              errorMessage: null,
              importedTagInformation: [
                ...prevState.importedTagInformation,
                ...importedTags,
              ],
            }));
          }
        } else {
          this.setState({
            errorMessage: "Invalid CSV headers, please use the CSV template.",
          });
        }
      },
    });
  }

  // Exports the currently-loaded tag list for this lock as a CSV that can be
  // fed straight back into handleString() above — same headers, same ";"
  // delimiter, and Tag-ID un-padded back to plain 4-hex-char form (handleString
  // stores it as " XX XX " internally).
  handleExportCSV() {
    const tagList = this.state.TagInformation || [];

    if (!tagList.length) {
      this.showNotification("No tags to export.", "warning", 5);
      return;
    }

    // Disambiguate repeated Tag-Names (e.g. two tags both named "Barth, Scott")
    // with a " (2)", " (3)", ... suffix, so the export both reads clearly and
    // can be re-imported without tripping handleString()'s duplicate-name check.
    const nameOccurrences = {};
    const csvData = tagList.map((tag, index) => {
      const originalName = tag.tagName || "";
      const occurrence = (nameOccurrences[originalName] =
        (nameOccurrences[originalName] || 0) + 1);
      const tagName =
        occurrence > 1 ? `${originalName} (${occurrence})` : originalName;

      return {
        "No.": index + 1,
        "Tag-Name": tagName,
        "Tag-ID": (tag.tagId || "").replace(/\s+/g, ""),
      };
    });

    const csvExporter = new ExportToCsv({
      filename: `tags-${this.state.lockName || this.state.lockserial}`,
      fieldSeparator: ";",
      // Must be a quote CHARACTER, not a boolean. export-to-csv's internal
      // escaper does `this._options.quoteStrings + data + this._options.quoteStrings`
      // for any value containing a comma (hardcoded, regardless of fieldSeparator) —
      // pass `false` and JS stringifies it to the literal text "false" wrapped
      // around every comma-containing Tag-Name (e.g. "Doe, Jane" -> "falseDoe, Janefalse").
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      useTextFile: false,
      useBom: true,
      headers: ["No.", "Tag-Name", "Tag-ID"],
    });

    csvExporter.generateCsv(csvData);
  }

  submitTagsOld() {
    const lockserial = this.state.lockserial;
    const lockName = this.state.lockName;
    const tagsToSubmit = this.state.importedTagInformation;

    const tagInformation = tagsToSubmit.map((tag) => ({
      ...tag,
      reply: 81,
      PageNumber: 0,
      imported: false,
      timeAdded: Math.floor(Date.now() / 1000),
    }));

    tagInformation.forEach((tag) => {
      fire
        .database()
        .ref("nfcTagList")
        .child(lockserial)
        .push(tag);
    });

    // Update the local state to show the correct import status
    const updatedTags = tagsToSubmit.map((tag) => ({
      ...tag,
      imported: "Pending",
    }));

    // Clear error messages and tags then update the tag list
    this.setState((prevState) => ({
      errorMessage: null,
      importedTagInformation: [],
      TagInformation: [...prevState.TagInformation, ...updatedTags],
      inputTagName: "",
      inputTagID: "",
      selectedTags: [],
    }));

    this.showNotification(
      `${localizationStrings.tagsAddedNotification +
        lockName +
        localizationStrings.notificationEnd}`,
      "success",
      5
    );
  }

  submitTags() {
    const lockserial = this.state.lockserial;
    const lockName = this.state.lockName;
    const tagsToSubmit = this.state.importedTagInformation;
    const MAX_TAGS = this.state.planLimits?.maxTagsPerLock ?? 200;

    fire
      .database()
      .ref("nfcTagList")
      .child(lockserial)
      .once("value")
      .then((snapshot) => {
        let existingTagCount = snapshot.numChildren();

        const remaining = Math.max(MAX_TAGS - existingTagCount, 0);
        if (remaining <= 0) {
          this.setState({
            errorMessage: `Cannot add more than ${MAX_TAGS} tags for your plan.`,
          });
          return;
        }

        const tagsWithinLimit = tagsToSubmit.slice(0, remaining);
        const dropped = tagsToSubmit.length - tagsWithinLimit.length;

        const tagInformation = tagsWithinLimit.map((tag) => ({
          ...tag,
          reply: 81,
          PageNumber: 0,
          imported: false,
          timeAdded: Math.floor(Date.now() / 1000),
        }));

        tagInformation.forEach((tag) => {
          fire
            .database()
            .ref("nfcTagList")
            .child(lockserial)
            .push(tag);
        });

        // Update the local state to show the correct import status
        const updatedTags = tagsWithinLimit.map((tag) => ({
          ...tag,
          imported: "Pending",
        }));

        // Clear error messages and tags then update the tag list
        this.setState((prevState) => ({
          errorMessage:
            dropped > 0
              ? `Added ${tagsWithinLimit.length} tags. ${dropped} could not be added — plan capped at ${MAX_TAGS} tags per lock.`
              : null,
          importedTagInformation: [],
          TagInformation: [...prevState.TagInformation, ...updatedTags],
          inputTagName: "",
          inputTagID: "",
          selectedTags: [],
        }));

        this.showNotification(
          `${localizationStrings.tagsAddedNotification +
            lockName +
            localizationStrings.notificationEnd}`,
          "success",
          5
        );
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }

  submitPasscodesOld() {
    const lockserial = this.state.lockserial;
    const lockName = this.state.lockName;
    const passcodesToSubmit = this.state.importedPasscodeInformation;

    fire
      .database()
      .ref("directionalPasscodeList")
      .child(lockserial)
      .once("value")
      .then((snapshot) => {
        let existingRecordCount = snapshot.numChildren();

        passcodesToSubmit.forEach((passcode) => {
          const passcodeInformation = {
            ...passcode,
            timestamp: Math.floor(Date.now() / 1000),
            index: existingRecordCount++,
          };

          const newRef = fire
            .database()
            .ref("directionalPasscodeList")
            .child(lockserial)
            .push();

          newRef.set({
            ...passcodeInformation,
            id: newRef.key,
          });
        });
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });

    // Clear error messages and passcodes then update the passcode list
    this.setState((prevState) => ({
      errorMessage: null,
      importedPasscodeInformation: [],
      PasscodeInformation: [
        ...prevState.PasscodeInformation,
        ...passcodesToSubmit,
      ],
      inputPasscodeName: "",
      inputPasscode: "",
      selectedPasscodes: [],
    }));

    this.showNotification(
      `${localizationStrings.passcodesAddedNotification +
        lockName +
        localizationStrings.notificationEnd}`,
      "success",
      5
    );
  }

  submitPasscodes() {
    const lockserial = this.state.lockserial;
    const lockName = this.state.lockName;
    const passcodesToSubmit = this.state.importedPasscodeInformation;
    const MAX_PASSCODES = this.state.planLimits?.maxPasscodesPerLock ?? 100;

    fire
      .database()
      .ref("directionalPasscodeList")
      .child(lockserial)
      .once("value")
      .then((snapshot) => {
        let existingRecordCount = snapshot.numChildren();

        const remaining = Math.max(MAX_PASSCODES - existingRecordCount, 0);
        if (remaining <= 0) {
          this.setState({
            errorMessage: `Cannot add more than ${MAX_PASSCODES} passcodes for your plan.`,
          });
          return;
        }

        const passcodesWithinLimit = passcodesToSubmit.slice(0, remaining);
        const dropped = passcodesToSubmit.length - passcodesWithinLimit.length;

        passcodesWithinLimit.forEach((passcode) => {
          const passcodeInformation = {
            ...passcode,
            timestamp: Math.floor(Date.now() / 1000),
            index: existingRecordCount++,
          };

          const newRef = fire
            .database()
            .ref("directionalPasscodeList")
            .child(lockserial)
            .push();

          newRef.set({
            ...passcodeInformation,
            id: newRef.key,
          });
        });

        // Clear error messages and passcodes then update the passcode list
        this.setState((prevState) => ({
          errorMessage:
            dropped > 0
              ? `Added ${passcodesWithinLimit.length} passcodes. ${dropped} could not be added — plan capped at ${MAX_PASSCODES} per lock.`
              : null,
          importedPasscodeInformation: [],
          PasscodeInformation: [
            ...prevState.PasscodeInformation,
            ...passcodesWithinLimit,
          ],
          inputPasscodeName: "",
          inputPasscode: "",
          selectedPasscodes: [],
        }));

        this.showNotification(
          `${localizationStrings.passcodesAddedNotification +
            lockName +
            localizationStrings.notificationEnd}`,
          "success",
          5
        );
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }

  removeSelectedTags() {
    const { importedTagInformation, selectedTags } = this.state;

    const updatedTags = importedTagInformation.filter(
      (tag) => !selectedTags.includes(tag.tagName)
    );

    this.setState({
      importedTagInformation: updatedTags,
      selectedTags: [],
    });
  }

  removeSelectedPasscodes() {
    const { importedPasscodeInformation, selectedPasscodes } = this.state;

    const updatedPasscodes = importedPasscodeInformation.filter(
      (passcode) => !selectedPasscodes.includes(passcode.name)
    );

    this.setState({
      importedPasscodeInformation: updatedPasscodes,
      selectedPasscodes: [],
    });
  }

  removeSelectedDBTags() {
    const { lockserial, lockName, selectedDBTags, TagInformation } = this.state;

    const dbRef = fire
      .database()
      .ref("nfcTagList")
      .child(lockserial);

    dbRef.once("value").then((snapshot) => {
      const tagsToRemove = {};
      snapshot.forEach((childSnapshot) => {
        const tagData = childSnapshot.val();
        const tagName = tagData.tagName;

        if (selectedDBTags.includes(tagName)) {
          tagsToRemove[childSnapshot.key] = null;
        }
      });

      return dbRef.update(tagsToRemove);
    });

    const updatedTagInformation = TagInformation.filter(
      (tag) => !selectedDBTags.includes(tag.tagName)
    );

    this.setState({
      TagInformation: updatedTagInformation,
      selectedDBTags: [],
    });

    this.showNotification(
      `${localizationStrings.tagsRemovedNotification +
        lockName +
        localizationStrings.notificationEnd}`,
      "success",
      5
    );
  }

  removeSelectedDBPasscodes() {
    const {
      lockserial,
      lockName,
      selectedDBPasscodes,
      PasscodeInformation,
    } = this.state;

    const dbRef = fire
      .database()
      .ref("directionalPasscodeList")
      .child(lockserial);

    dbRef.once("value").then((snapshot) => {
      const passcodesToRemove = {};
      snapshot.forEach((childSnapshot) => {
        const passcodeData = childSnapshot.val();
        const passcodeName = passcodeData.name;

        if (selectedDBPasscodes.includes(passcodeName)) {
          passcodesToRemove[childSnapshot.key] = null;
        }
      });

      return dbRef.update(passcodesToRemove);
    });

    const updatedPasscodeInformation = PasscodeInformation.filter(
      (passcode) => !selectedDBPasscodes.includes(passcode.name)
    );

    this.setState({
      PasscodeInformation: updatedPasscodeInformation,
      selectedDBPasscodes: [],
    });

    this.showNotification(
      `${localizationStrings.passcodesRemovedNotification +
        lockName +
        localizationStrings.notificationEnd}`,
      "success",
      5
    );
  }

  handleRadioChange = (event) => {
    this.setState({
      selectedAddType: event.target.value,
      errorMessage: null,
      inputTagName: "",
      inputTagID: "",
    });
  };

  renderAddForm() {
    return (
      <div>
        <div
          style={{
            marginTop: "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <input
            type="text"
            placeholder={localizationStrings.TagName}
            value={this.state.inputTagName}
            onChange={(e) => this.setState({ inputTagName: e.target.value })}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid grey",
              width: "49%",
            }}
          />
          <input
            type="text"
            placeholder={localizationStrings.TagId}
            value={this.state.inputTagID}
            onChange={(e) => this.setState({ inputTagID: e.target.value })}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid grey",
              width: "49%",
            }}
          />
        </div>
        <div style={{ margin: "15px 0px 0px 0px" }}>
          <button
            style={{
              width: "135px",
              padding: "5px",
              backgroundColor: "white",
              border: "1px solid black",
              borderRadius: "5px",
            }}
            onClick={() => this.handleAddTag()}
            disabled={
              this.state.inputTagName == "" || this.state.inputTagID == ""
                ? true
                : false
            }
          >
            {localizationStrings.addLabel}
          </button>
          {this.state.errorMessage && (
            <div style={{ color: "red", marginTop: "15px" }}>
              {this.state.errorMessage}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderImportForm() {
    return (
      <div>
        <div
          style={{
            marginTop: "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <input
            type="file"
            accept=".csv"
            onChange={(event) => {
              this.setState(
                {
                  csvdata: event.target.files[0],
                },
                () => console.log(this.state.csvdata)
              );
            }}
          />
          <p style={{ fontSize: "1em" }}>
            {localizationStrings.CSVTemplateTitle}
            <a
              href="tags.csv"
              download="tags.csv"
              style={{ color: "blue", textDecoration: "underline" }}
            >
              {localizationStrings.CSVDownloadTitle}
            </a>
          </p>
        </div>
        <div style={{ margin: "10px 0px 0px 0px" }}>
          <button
            style={{
              width: "135px",
              padding: "5px",
              backgroundColor: "white",
              border: "1px solid black",
              borderRadius: "5px",
            }}
            onClick={() => this.handleString(this.state.csvdata)}
            disabled={
              this.state.csvdata == {} ||
              this.state.csvdata == null ||
              this.state.csvdata == undefined
                ? true
                : false
            }
          >
            {localizationStrings.importBtnTitle}
          </button>
          {this.state.errorMessage && (
            <div style={{ color: "red", marginTop: "15px" }}>
              {this.state.errorMessage}
            </div>
          )}
        </div>
      </div>
    );
  }

  handleAddTag() {
    const {
      inputTagName,
      inputTagID,
      TagInformation,
      importedTagInformation,
    } = this.state;

    const tagName = inputTagName.trim();
    const tagId = inputTagID.trim();
    let formattedTagId = null;

    // Tag ID validation
    const isValidTagID = /^[A-Fa-f0-9]{4}$/.test(tagId);

    // Check for duplicate Tag Names
    const isDuplicateTagName =
      TagInformation.some((tag) => tag.tagName === tagName) ||
      importedTagInformation.some((tag) => tag.tagName === tagName);

    let isDuplicateTagId = null;

    if (isValidTagID) {
      // Format inputted Tag ID
      formattedTagId = ` ${tagId.slice(0, 2).toUpperCase()} ${tagId
        .slice(2, 4)
        .toUpperCase()} `;

      // Check for duplicate Tag IDs
      isDuplicateTagId =
        TagInformation.some((tag) => tag.tagId === formattedTagId) ||
        importedTagInformation.some((tag) => tag.tagId === formattedTagId);
    }

    if (isDuplicateTagName || isDuplicateTagId || !isValidTagID) {
      let errorMessage = "";

      if (isDuplicateTagName) {
        errorMessage += localizationStrings.tagErrorMessage1;
      }

      if (isDuplicateTagId) {
        errorMessage += localizationStrings.tagErrorMessage2;
      }

      if (!isValidTagID) {
        errorMessage += localizationStrings.tagErrorMessage3;
      }

      this.setState({ errorMessage });
    } else {
      const newTag = { tagName, tagId: formattedTagId };

      this.setState((prevState) => ({
        importedTagInformation: [...prevState.importedTagInformation, newTag],
        errorMessage: null,
        inputTagName: "",
        inputTagID: "",
      }));
    }
  }

  handleAddPasscode() {
    const {
      inputPasscodeName,
      inputPasscode,
      PasscodeInformation,
      importedPasscodeInformation,
    } = this.state;

    const passcodeName = inputPasscodeName.trim();
    const passcode = inputPasscode.trim();
    let directionalPasscode = null;
    let directionalEmoji = null;

    // Passcode validation
    const isValidPasscode = /^[0-9]{6}$/.test(passcode);

    // Check for duplicate Passcode Names
    const isDuplicatePasscodeName =
      PasscodeInformation.some((passcode) => passcode.name === passcodeName) ||
      importedPasscodeInformation.some(
        (passcode) => passcode.name === passcodeName
      );

    let isDuplicatePasscode = null;

    if (isValidPasscode) {
      // Change inputted passcode into directional passcode
      directionalPasscode = passcode
        .split("")
        .map((char) => {
          const num = parseInt(char);
          if (num === 1 || num === 2 || num === 3) {
            return "1";
          } else if (num === 4 || num === 5) {
            return "4";
          } else if (num === 6 || num === 7 || num === 8) {
            return "3";
          } else if (num === 9 || num === 0) {
            return "2";
          }
        })
        .join("");

      // Change inputted passcode into directional emoji
      directionalEmoji = passcode
        .split("")
        .map((char) => {
          const num = parseInt(char);
          if (num === 1 || num === 2 || num === 3) {
            return "⬆";
          } else if (num === 4 || num === 5) {
            return "⮕";
          } else if (num === 6 || num === 7 || num === 8) {
            return "⬇";
          } else if (num === 9 || num === 0) {
            return "⬅";
          }
        })
        .join("");

      // Check for duplicate Passcodes
      isDuplicatePasscode =
        PasscodeInformation.some(
          (passcode) => passcode.directionalPasscode === directionalPasscode
        ) ||
        importedPasscodeInformation.some(
          (passcode) => passcode.directionalPasscode === directionalPasscode
        );
    }

    if (isDuplicatePasscodeName || isDuplicatePasscode || !isValidPasscode) {
      let errorMessage = "";

      if (isDuplicatePasscodeName) {
        errorMessage += localizationStrings.passcodeErrorMessage1;
      }

      if (isDuplicatePasscode) {
        errorMessage += localizationStrings.passcodeErrorMessage2;
      }

      if (!isValidPasscode) {
        errorMessage += localizationStrings.passcodeErrorMessage3;
      }

      this.setState({ errorMessage });
    } else {
      const newPasscode = {
        name: passcodeName,
        directionalPasscode,
        directionalEmoji,
      };
      // console.log(newPasscode);

      this.setState((prevState) => ({
        importedPasscodeInformation: [
          ...prevState.importedPasscodeInformation,
          newPasscode,
        ],
        errorMessage: null,
        inputPasscodeName: "",
        inputPasscode: "",
      }));
    }
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const {
      selectedTags,
      selectedPasscodes,
      selectedDBTags,
      selectedDBPasscodes,
    } = this.state;

    let selectRow = null;
    let selectRow2 = null;

    if (
      this.state.lockType !== 7 &&
      this.state.lockType != 8 &&
      this.state.lockType != 9
    ) {
      selectRow = {
        mode: "checkbox",
        clickToSelect: true,
        selected: selectedTags,
        onSelect: (row, isSelected) => {
          const tagName = row.tagName;
          let newSelectedTags;

          if (isSelected) {
            newSelectedTags = [...selectedTags, tagName];
          } else {
            newSelectedTags = selectedTags.filter((tag) => tag !== tagName);
          }

          this.setState({ selectedTags: newSelectedTags });
        },
        onSelectAll: (isSelected) => {
          const allTagNames = this.state.importedTagInformation.map(
            (tag) => tag.tagName
          );
          const newSelectedTags = isSelected ? allTagNames : [];
          this.setState({ selectedTags: newSelectedTags });
        },
      };

      selectRow2 = {
        mode: "checkbox",
        clickToSelect: true,
        selected: selectedDBTags,
        onSelect: (row, isSelected) => {
          const tagName = row.tagName;
          let newSelectedDBTags;

          if (isSelected) {
            newSelectedDBTags = [...selectedDBTags, tagName];
          } else {
            newSelectedDBTags = selectedDBTags.filter((tag) => tag !== tagName);
          }

          this.setState({ selectedDBTags: newSelectedDBTags });
        },
        onSelectAll: (isSelected) => {
          const allTagNames = this.state.TagInformation.map(
            (tag) => tag.tagName
          );
          const newSelectedDBTags = isSelected ? allTagNames : [];
          this.setState({ selectedDBTags: newSelectedDBTags });
        },
      };
    } else if (
      this.state.lockType === 7 ||
      this.state.lockType === 8 ||
      this.state.lockType === 9
    ) {
      selectRow = {
        mode: "checkbox",
        clickToSelect: true,
        selected: selectedPasscodes,
        onSelect: (row, isSelected) => {
          const passcodeName = row.name;
          let newSelectedPasscodes;

          if (isSelected) {
            newSelectedPasscodes = [...selectedPasscodes, passcodeName];
          } else {
            newSelectedPasscodes = selectedPasscodes.filter(
              (passcode) => passcode !== passcodeName
            );
          }

          this.setState({ selectedPasscodes: newSelectedPasscodes });
        },
        onSelectAll: (isSelected) => {
          const allPasscodeNames = this.state.importedPasscodeInformation.map(
            (passcode) => passcode.name
          );
          const newSelectedPasscodes = isSelected ? allPasscodeNames : [];
          this.setState({ selectedPasscodes: newSelectedPasscodes });
        },
      };

      selectRow2 = {
        mode: "checkbox",
        clickToSelect: true,
        selected: selectedDBPasscodes,
        onSelect: (row, isSelected) => {
          const passcodeName = row.name;
          let newSelectedDBPasscodes;

          if (isSelected) {
            newSelectedDBPasscodes = [...selectedDBPasscodes, passcodeName];
          } else {
            newSelectedDBPasscodes = selectedDBPasscodes.filter(
              (passcode) => passcode !== passcodeName
            );
          }

          this.setState({ selectedDBPasscodes: newSelectedDBPasscodes });
        },
        onSelectAll: (isSelected) => {
          const allPasscodeNames = this.state.PasscodeInformation.map(
            (passcode) => passcode.name
          );
          const newSelectedDBPasscodes = isSelected ? allPasscodeNames : [];
          this.setState({ selectedDBPasscodes: newSelectedDBPasscodes });
        },
      };
    }

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    return (
      <div>
        {/* Table pagination styling/spacing for tag/passcode management */}
        <style>
          {`
            .tagManagement .pagination, .passcodeManagement .pagination {
              margin-bottom: -10px !important;
            }

            .addTagConfirmation .pagination, .addPasscodeConfirmation .pagination {
              margin-bottom: -60px !important;
            }

            .tagManagement .col-lg-6, .passcodeManagement .col-lg-6 {
              width: 100%;
            }
          `}
        </style>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Modal show={this.state.showPopup} onHide={this.handlePopupClose}>
          <Modal.Header closeButton>
            {this.state.lockType !== 7 &&
              this.state.lockType !== 8 &&
              this.state.lockType !== 9 && (
                <Modal.Title>
                  {localizationStrings.TagInformation +
                    " - " +
                    this.state.lockName}
                </Modal.Title>
              )}
            {(this.state.lockType === 7 ||
              this.state.lockType === 8 ||
              this.state.lockType === 9) && (
              <Modal.Title>
                {localizationStrings.PasscodeInformation +
                  " - " +
                  this.state.lockName}
              </Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body>
            {this.state.lockType !== 7 &&
              this.state.lockType !== 8 &&
              this.state.lockType !== 9 && (
                <div className="tagManagement">
                  {/* <div style={{ margin: "-5px 0px 10px 0px" }}>
                  <button
                    style={{
                      padding: "8px 12px",
                      backgroundColor: "red",
                      color: "white",
                      borderRadius: "20px",
                      border: "none",
                    }}
                    onClick={() => this.removeSelectedDBTags()}
                    disabled={selectedDBTags.length === 0 ? true : false}
                  >
                    {localizationStrings.removeSelectedLabel}
                  </button>
                </div> */}
                  <div style={{ margin: "-5px 0px 10px 0px" }}>
                    <button
                      style={{
                        padding: "8px 12px",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        borderRadius: "20px",
                      }}
                      onClick={this.handleExportCSV}
                    >
                      {localizationStrings.exportBtnTitle}
                    </button>
                  </div>
                  <BootstrapTable
                    pagination
                    bordered={true}
                    // selectRow={selectRow2}
                    data={this.state.TagInformation}
                    options={{
                      sizePerPage: 5,
                      hideSizePerPage: true,
                      noDataText: this.state.noDataText,
                      paginationSize: 3,
                    }}
                  >
                    <TableHeaderColumn
                      isKey={true}
                      dataField="tagName"
                      columnTitle={columnHover}
                    >
                      {localizationStrings.TagName}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="tagId"
                      columnTitle={columnHover}
                    >
                      {localizationStrings.TagId}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="imported"
                      columnTitle={columnHover}
                    >
                      {localizationStrings.ImportStatus}
                    </TableHeaderColumn>
                  </BootstrapTable>
                  {(this.state.lockType === 10 ||
                    this.state.lockType === 11 ||
                    this.state.lockType === 12) && (
                    <React.Fragment>
                      <p style={{ fontSize: "18px" }}>
                        {localizationStrings.addImportHeader}
                      </p>
                      <div>
                        <label style={{ marginRight: "20px" }}>
                          <input
                            type="radio"
                            value="add"
                            checked={this.state.selectedAddType === "add"}
                            onChange={this.handleRadioChange}
                            style={{ marginRight: "5px" }}
                          />
                          {localizationStrings.addLabel}
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="import"
                            checked={this.state.selectedAddType === "import"}
                            onChange={this.handleRadioChange}
                            style={{ marginRight: "5px" }}
                          />
                          {localizationStrings.importBtnTitle}
                        </label>
                      </div>
                      {this.state.selectedAddType === "add"
                        ? this.renderAddForm()
                        : this.renderImportForm()}
                      {this.state.importedTagInformation.length > 0 && (
                        <div className="addTagConfirmation">
                          <p style={{ fontSize: "18px", marginTop: "25px" }}>
                            {localizationStrings.confirmAddTagHeader}
                          </p>
                          <div style={{ margin: "15px 0px 10px 0px" }}>
                            <button
                              style={{
                                padding: "8px 12px",
                                backgroundColor: "red",
                                color: "white",
                                borderRadius: "20px",
                                border: "none",
                              }}
                              onClick={() => this.removeSelectedTags()}
                              disabled={
                                selectedTags.length === 0 ? true : false
                              }
                            >
                              {localizationStrings.removeSelectedLabel}
                            </button>
                          </div>
                          <BootstrapTable
                            pagination
                            selectRow={selectRow}
                            data={this.state.importedTagInformation}
                            bordered={true}
                            options={{
                              sizePerPage: 5,
                              hideSizePerPage: true,
                              noDataText: this.state.noDataText,
                              paginationSize: 3,
                            }}
                          >
                            <TableHeaderColumn
                              isKey={true}
                              dataField="tagName"
                              columnTitle={columnHover}
                            >
                              {localizationStrings.TagName}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                              dataField="tagId"
                              columnTitle={columnHover}
                            >
                              {localizationStrings.TagId}
                            </TableHeaderColumn>
                          </BootstrapTable>
                          <button
                            style={{
                              width: "135px",
                              padding: "5px",
                              backgroundColor: "white",
                              border: "1px solid black",
                              borderRadius: "5px",
                            }}
                            onClick={() => this.submitTags()}
                            disabled={
                              this.state.importedTagInformation == []
                                ? true
                                : false
                            }
                          >
                            {localizationStrings.addTagsLabel}
                          </button>
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </div>
              )}
            {(this.state.lockType === 7 ||
              this.state.lockType === 8 ||
              this.state.lockType === 9) && (
              <div className="passcodeManagement">
                {/* <div style={{ margin: "-5px 0px 10px 0px" }}>
                  <button
                    style={{
                      padding: "8px 12px",
                      backgroundColor: "red",
                      color: "white",
                      borderRadius: "20px",
                      border: "none",
                    }}
                    onClick={() => this.removeSelectedDBPasscodes()}
                    disabled={selectedDBPasscodes.length === 0 ? true : false}
                  >
                    {localizationStrings.removeSelectedLabel}
                  </button>
                </div> */}
                <BootstrapTable
                  pagination
                  bordered={true}
                  // selectRow={selectRow2}
                  data={this.state.PasscodeInformation}
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    noDataText: this.state.noDataText,
                    paginationSize: 3,
                  }}
                >
                  <TableHeaderColumn
                    isKey={true}
                    dataField="name"
                    columnTitle={columnHover}
                  >
                    {localizationStrings.PasscodeName}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="directionalEmoji"
                    columnTitle={columnHover}
                  >
                    {localizationStrings.Passcode}
                  </TableHeaderColumn>
                  {/* <TableHeaderColumn dataField="imported" columnTitle={columnHover}>
                    {localizationStrings.ImportStatus}
                  </TableHeaderColumn> */}
                </BootstrapTable>

                {/* loto cannot import */}
                {/* <p style={{ fontSize: "18px" }}>
                  {localizationStrings.addPasscodeLabel}
                </p>
                <div
                  style={{
                    margin: "20px 55px 15px 0",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <p>{localizationStrings.directionalCodeLabel}</p>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <p>1 2 3</p>
                    <p>⬆</p>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <p>4 5</p>
                    <p>⮕</p>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <p>6 7 8</p>
                    <p>⬇</p>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <p>9 0</p>
                    <p>⬅</p>
                  </div>
                </div>
                <div
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <input
                    type="text"
                    placeholder={localizationStrings.PasscodeName}
                    value={this.state.inputPasscodeName}
                    onChange={(e) =>
                      this.setState({ inputPasscodeName: e.target.value })
                    }
                    style={{
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid grey",
                      width: "49%",
                    }}
                  />
                  <input
                    type="text"
                    placeholder={localizationStrings.Passcode}
                    value={this.state.inputPasscode}
                    onChange={(e) =>
                      this.setState({ inputPasscode: e.target.value })
                    }
                    style={{
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid grey",
                      width: "49%",
                    }}
                  />
                </div>
                <div style={{ margin: "15px 0px 0px 0px" }}>
                  <button
                    style={{
                      width: "135px",
                      padding: "5px",
                      backgroundColor: "white",
                      border: "1px solid black",
                      borderRadius: "5px",
                    }}
                    onClick={() => this.handleAddPasscode()}
                    disabled={
                      this.state.inputPasscodeName == "" ||
                      this.state.inputPasscode == ""
                        ? true
                        : false
                    }
                  >
                    {localizationStrings.addLabel}
                  </button>
                  {this.state.errorMessage && (
                    <div style={{ color: "red", marginTop: "15px" }}>
                      {this.state.errorMessage}
                    </div>
                  )}
                </div> 
                {this.state.importedPasscodeInformation.length > 0 && (
                  <div className="addPasscodeConfirmation">
                    <p style={{ fontSize: "18px", marginTop: "25px" }}>
                      {localizationStrings.confirmAddPasscodeHeader}
                    </p>
                    <div style={{ margin: "15px 0px 10px 0px" }}>
                      <button
                        style={{
                          padding: "8px 12px",
                          backgroundColor: "red",
                          color: "white",
                          borderRadius: "20px",
                          border: "none",
                        }}
                        onClick={() => this.removeSelectedPasscodes()}
                        disabled={selectedPasscodes.length === 0 ? true : false}
                      >
                        {localizationStrings.removeSelectedLabel}
                      </button>
                    </div>
                    <BootstrapTable
                      pagination
                      selectRow={selectRow}
                      data={this.state.importedPasscodeInformation}
                      bordered={true}
                      options={{
                        sizePerPage: 5,
                        hideSizePerPage: true,
                        noDataText: this.state.noDataText,
                        paginationSize: 3,
                      }}
                    >
                      <TableHeaderColumn
                        isKey={true}
                        dataField="name"
                        columnTitle={columnHover}
                      >
                        {localizationStrings.PasscodeName}
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="directionalEmoji"
                        columnTitle={columnHover}
                      >
                        {localizationStrings.Passcode}
                      </TableHeaderColumn>
                    </BootstrapTable>
                    <button
                      style={{
                        width: "135px",
                        padding: "5px",
                        backgroundColor: "white",
                        border: "1px solid black",
                        borderRadius: "5px",
                      }}
                      onClick={() => this.submitPasscodes()}
                      disabled={
                        this.state.importedPasscodeInformation == []
                          ? true
                          : false
                      }
                    >
                      {localizationStrings.addPasscodeLabel}
                    </button>
                  </div>
                )} */}
              </div>
            )}
          </Modal.Body>
        </Modal>

        <Button
          onClick={this.handlePopupOpen}
          className="btn btn-info"
          style={{ borderRadius: "50px" }}
        >
          {/* {localizationStrings.showInfoButton} */}
          {this.state.lockType !== 7 &&
            this.state.lockType !== 8 &&
            this.state.lockType !== 9 &&
            localizationStrings.manageTags}
          {(this.state.lockType === 7 ||
            this.state.lockType === 8 ||
            this.state.lockType === 9) &&
            localizationStrings.managePasscodes}
        </Button>
      </div>
    );
  }
}

export default TagInfoButton;
